// extracted by mini-css-extract-plugin
module.exports = {"tablerow":"ClickableTableRow_tablerow__2Zljh"};